import {makeAutoObservable} from "mobx";
import {createFile} from "../http/FileAPI";

export default class FileStore {
    file = []
    constructor() {
        makeAutoObservable(this)
    }

    setFile(file) {
        this.file = file
    }

    async addNewFile (file) {
        try {
            const {data} = await createFile(file)
            this.setFile(data.file)
        } catch (e) {
            console.log(e.response?.data?.message)
        }
    }


}